// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-page-navigation[data-v-71bc7f7c]{display:flex}.payment-page-navigation button[data-v-71bc7f7c]{margin-right:1rem}.payment-page-navigation button[data-v-71bc7f7c]:last-child{margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
